const API_URL = 'https://rocky-taiga-84156-5ebadf719ce4.herokuapp.com';

export default API_URL; 